import { render, staticRenderFns } from "./ProjectMilestoneEditForm.vue?vue&type=template&id=3d9a7941&"
import script from "./ProjectMilestoneEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectMilestoneEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports